import {OeMbl} from "../../../../fms.core/OeMbl";
import _ from "lodash";
import {DefaultContainerMilestoneStatus} from "./implementationConstants";
import {MblStatusViewModel, OceanMblStatusMap, OeContainerEvents} from "../../../../fms.core/MblStatusViewModel";
import {PimsContainer} from "../../../../fms.core/pims/PimsContainer";
import {PimsCntrEvent} from "../../../../fms.core/PimsCntrEvent";

export function apiResultToDataModel(data: OeMbl) {
  // @ts-ignore:next-line
  const result: OceanExportMbl = {
    ...data,
    dutyAgentPreset: data.dutyAgent ? {id: data.dutyAgent, shortName: data.dutyAgentName} : undefined,
    dutyCustomerPreset: data.dutyCustomer ? {id: data.dutyCustomer, shortName: data.dutyCustomerName} : undefined,
    mblCustomer: data.mblCustomer ? {id: data.mblCustomer, shortName: data.mblCustomerName} : undefined,
    mblCustomer2: data.mblCustomer2 ? {id: data.mblCustomer2, shortName: data.mblCustomer2Name} : undefined,
    freightVendor: data.carrier ? {id: data.carrier, shortName: data.carrierName} : undefined,
    mblAgent1: data.agent ? {id: data.agent, shortName: data.agentName} : undefined,
    mblAgent2: data.agent2 ? {id: data.agent2, shortName: data.agent2Name}: undefined,
    mblAgent3: data.agent3 ? {id: data.agent3, shortName: data.agent3Name} : undefined,
    containerInfo: data.container ? {lineItems: data.container.map((container: any) => {
      return {
        ...container,
        id: container.id,
        numberOfPackages: container.pkgs,
        containerNumber: container.containerNo,
        type: container.conType,
        sealNumber: container.sealNo,
        unit: container.pUnit,
        weightKgs: container.kgs,
        weightLbs: container.lbs,
        serialNumber: container.serialNo,
        milestone: _.cloneDeep(DefaultContainerMilestoneStatus),
        flexiTank: {
          id: container.id,
          containerNumber: container.containerNo,
          type: container.conType,
          tankSize: container.tankSize,
          fitBy: container.fitBy,
          fitByDate: container.fitByDate,
          commodity: container.commodity,
          payload: container.payload,
          capacity: container.capacity,
          puNumber: container.puNo,
          loadDate: container.loadDate,
          sealNumber: container.sealNo,
          sealNumber2: container.sealNo2,
          sealNumber3: container.sealNo3,
          serialNumber: container.serialNo,
          grossWeight: container.gKgs,
          netWeight: container.netKgs,
          cbm: container.cbm,
          gallon: container.gallon,
          hts: container.hts,
        }
      }
      })} : undefined,
    updateBy: data.u2Id,
    updateDate: data.u2Date,
    direct: data.directBl,
    containerMode: data.lclfcl,
    subMblNo: data.sMblNo,
    freightPayment: data.ppcc,
    voyageNo: data.voyage,
    salesperson: {id: data.msManID, group: '', inactive: false, name: data.msManID},
    truckCompany: data.truckCom ? {id: data.truckCom, shortName: data.truckComName}: undefined,
    vesselName: data.vessel ? {id: data.vessel, shortName: data.vessel}: undefined,
    vesselCarrier: data.steamShip ? {id: data.steamShip, shortName: data.steamShipName}: undefined,
    portOfLoading: data.loadingPort ? {unPortName: data.loadingPort, unCode: data.unlCode, usCode: data.uslCode}: undefined,
    portOfDischarge: data.discharge ? {unPortName: data.discharge, unCode: data.undCode, usCode: data.usdCode}: undefined,
    emptyPuLoc: data.emptyPuLoc ? {id: data.emptyPuLoc, shortName: data.emptyPuLoc} : undefined,
    plofRec: data.plofRec ? {id: data.plofRec, shortName: data.plofRec} : undefined,
    receivingStation: data.rstation ? {id: data.rstation, shortName: data.rstationName} : undefined,
    //plOfDstRtn: data.plOfDstRtn ? {id: data.plOfDstRtn, shortName: data.plOfDstRtn} : undefined,
    shipper: data.shipper ? {id: data.shipper, shortName: data.shipperName} : undefined,
    consignee: data.consignee ? {id: data.consignee, shortName: data.consigneeName} : undefined,
    notifyParty: data.notify ? {id: data.notify, shortName: data.notifyName} : {id: 0, shortName: 'Same as Consignee'},
    notifyPartyDetails: data.notifyName || 'Same as Consignee',
    forwardAgent: data.forwardAgent ? {id: data.forwardAgent, shortName: data.forwardAgentName} : undefined,
    serviceContractNo: data.svccNo,
    lot: data.lotNo,
    hblCount: data.hblNoCnt,
    pickupEmptyContainerLocation: data.emptyPuLoc,
    //bookConfirmDate: !!data.bookCfrm,
    //sedSentDate: !!data.sedSent,
    sedCutoffDate: !!data.sedCutoff,
    //arrangeTruckDate: !!data.arrangeTruck,
    //pickupEmptyContainerDate: !!data.emptyPickup,
    //pickupLoadContainerDate: !!data.loadPickup,
    pickupLoadContainerLocation: !!data.plofRec,
    //deliverToCarrierDate: !!data.dlvrToCarr,
    //fileAesDate: !!data.aesFile,
    //oceanCargoManifestSentDate: !!data.sendManifest,
    //agentDocPackageSentDate: !!data.sendAgtDoc,

    //bookConfirmDateTimestamp: data.bookCfrm,
    //sedSentDateTimestamp: data.sedSent,
    //arrangeTruckDateTimestamp: data.arrangeTruck,
    //pickupEmptyContainerDateTimestamp: data.emptyPickup,
    pickupEmptyContainerLocationTimestamp: data.emptyPuLoc,
    //pickupLoadContainerDateTimestamp: data.loadPickup,
    pickupLoadContainerLocationTimestamp: data.plofRec,
    //deliverToCarrierDateTimestamp: data.dlvrToCarr,
    //fileAesDateTimestamp: data.aesFile,
    //oceanCargoManifestSentDateTimestamp: data.sendManifest,
    //agentDocPackageSentDateTimestamp: data.sendAgtDoc,
  }

  return result;
}

export function prepareOeMblForView(mbl:OeMbl) {
  // Init milestone
  if(!mbl.milestone) {
    mbl.milestone = new MblStatusViewModel();
  }
  if(mbl.milestone.eventItemList.length > 0) {
    _.remove(mbl.milestone.eventItemList);
  }

  if(mbl.milestone.cntrItemList == null) mbl.milestone.cntrItemList = [];
  if(mbl.milestone.eventItemList == null) mbl.milestone.eventItemList = [];

  if (!mbl.milestone.cntrItemList || mbl.milestone.cntrItemList.length === 0) {
    AddPimsCntrEvent(mbl, new PimsContainer({ bookingId: mbl.pimsLinkId, cntrNo: mbl.mblNo }))
  }
  else {
    mbl.milestone.cntrItemList.forEach(x => {
      AddPimsCntrEvent(mbl, x)
    })
  }
}

function AddPimsCntrEvent(mbl:OeMbl, pimsContainer:PimsContainer){
  OeContainerEvents.forEach((enumEvent) => {
    // let seqNo = 0;
    const smitem = OceanMblStatusMap.get(enumEvent);
    if(!smitem) return;
    mbl.milestone?.eventItemList?.push(new PimsCntrEvent({
      pimsCntrId: pimsContainer.id,
      cntrNo: pimsContainer.cntrNo,
      pickupNo: pimsContainer.pickupNo,
      name: smitem.label,
      lastDate: _.get(pimsContainer, smitem.pimsCntrDate??''),
      locName: _.get(pimsContainer, smitem.pimsCntrLoc??''),
      seq: enumEvent,   //seqNo++,
      isVisible: true
    }));
  });
}